// Internal helper to generate a function to obtain property `key` from `obj`.
export default function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_shallowProperty.js
// module id = 944
// module chunks = 1